import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/components/Layout.vue'

// 菜单配置（写死在前端）
export const menuList = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/index.vue'),
    meta: { title: '数据面板', icon: 'DataLine' }
  },
  {
    path: '/agent',
    name: 'Agent',
    meta: { title: '代理运营商管理', icon: 'UserFilled' },
    children: [
      { path: '/agent/create', name: 'AgentCreate', component: () => import('@/views/agent/create.vue'), meta: { title: '代理账号创建' } },
      { path: '/agent/list', name: 'AgentList', component: () => import('@/views/agent/list.vue'), meta: { title: '代理列表管理' } },
      { path: '/agent/data', name: 'AgentData', component: () => import('@/views/agent/data.vue'), meta: { title: '代理数据查看' } },
      { path: '/agent/domain', name: 'AgentDomain', component: () => import('@/views/agent/domain.vue'), meta: { title: '域名配置管理' } }
    ]
  },
  {
    path: '/system',
    name: 'System',
    meta: { title: '系统设置', icon: 'Setting' },
    children: [
      { path: '/system/game-switch', name: 'GameSwitch', component: () => import('@/views/system/game-switch.vue'), meta: { title: '游戏总开关' } },
      { path: '/system/global-config', name: 'GlobalConfig', component: () => import('@/views/system/global-config.vue'), meta: { title: '全局配置' } },
      { path: '/system/api-config', name: 'ApiConfig', component: () => import('@/views/system/api-config.vue'), meta: { title: 'API配置' } },
      { path: '/system/deploy', name: 'Deploy', component: () => import('@/views/system/deploy.vue'), meta: { title: '发布功能' } },
      { path: '/system/register-limit', name: 'RegisterLimit', component: () => import('@/views/system/register-limit.vue'), meta: { title: '注册限制' } },
      { path: '/system/ip-blacklist', name: 'IpBlacklist', component: () => import('@/views/system/ip-blacklist.vue'), meta: { title: 'IP黑名单' } }
    ]
  },
  {
    path: '/monitor',
    name: 'Monitor',
    meta: { title: '监控面板', icon: 'Monitor' },
    children: [
      { path: '/monitor/order-log', name: 'OrderLog', component: () => import('@/views/monitor/order-log.vue'), meta: { title: '订单日志' } },
      { path: '/monitor/operation-log', name: 'OperationLog', component: () => import('@/views/monitor/operation-log.vue'), meta: { title: '操作日志' } },
      { path: '/monitor/pay-log', name: 'PayLog', component: () => import('@/views/monitor/pay-log.vue'), meta: { title: '支付日志' } },
      { path: '/monitor/agent-status', name: 'AgentStatus', component: () => import('@/views/monitor/agent-status.vue'), meta: { title: '代理运行状态' } },
      { path: '/monitor/slow-log', name: 'SlowLog', component: () => import('@/views/monitor/slow-log.vue'), meta: { title: '慢日志监控' } },
      { path: '/monitor/tron-collector', name: 'TronCollector', component: () => import('@/views/monitor/tron-collector.vue'), meta: { title: 'Tron 区块采集' } }
    ]
  },
  {
    path: '/activity',
    name: 'Activity',
    meta: { title: '活动管理', icon: 'Present' },
    children: [
      { path: '/activity/platform', name: 'PlatformActivity', component: () => import('@/views/activity/platform.vue'), meta: { title: '平台活动配置' } },
      { path: '/activity/agent', name: 'AgentActivity', component: () => import('@/views/activity/agent.vue'), meta: { title: '代理活动控制' } },
      { path: '/activity/analysis', name: 'ActivityAnalysis', component: () => import('@/views/activity/analysis.vue'), meta: { title: '活动效果分析' } }
    ]
  },
  {
    path: '/permission',
    name: 'Permission',
    meta: { title: '权限管理', icon: 'Lock' },
    children: [
      { path: '/permission/role', name: 'RoleManage', component: () => import('@/views/permission/role.vue'), meta: { title: '角色管理' } },
      { path: '/permission/menu', name: 'MenuManage', component: () => import('@/views/permission/menu.vue'), meta: { title: '菜单管理' } },
      { path: '/permission/role-menu', name: 'RoleMenu', component: () => import('@/views/permission/role-menu.vue'), meta: { title: '角色权限分配' } },
      { path: '/permission/agent-feature', name: 'AgentFeature', component: () => import('@/views/permission/agent-feature.vue'), meta: { title: '代理功能权限' } },
      { path: '/permission/agent-game', name: 'AgentGame', component: () => import('@/views/permission/agent-game.vue'), meta: { title: '代理游戏权限' } },
      { path: '/permission/admin', name: 'AdminPermission', component: () => import('@/views/permission/admin.vue'), meta: { title: '管理员权限' } }
    ]
  },
  {
    path: '/notice',
    name: 'Notice',
    meta: { title: '公告管理', icon: 'Bell' },
    children: [
      { path: '/notice/global', name: 'GlobalNotice', component: () => import('@/views/notice/global.vue'), meta: { title: '全服公告' } },
      { path: '/notice/agent', name: 'AgentNotice', component: () => import('@/views/notice/agent.vue'), meta: { title: '代理公告' } },
      { path: '/notice/update', name: 'UpdateNotice', component: () => import('@/views/notice/update.vue'), meta: { title: '游戏更新公告' } }
    ]
  },
  {
    path: '/profile',
    name: 'Profile',
    hidden: true,
    component: () => import('@/views/profile/index.vue'),
    meta: { title: '个人中心', icon: 'User' }
  }
]

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: menuList
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    hidden: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.path === '/login') {
    if (token) {
      next('/')
    } else {
      next()
    }
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
